export enum ServicesAustraliaPermissions {
    ModuleCode = 'ServicesAustralia',
    AdministrationCreate = 'ServicesAustralia_AdministrationCreate',
    AdministrationGeneral = 'ServicesAustralia_AdministrationGeneral',
    PerformMedicareCardVerification = 'ServicesAustralia_PerformMedicareCardVerification',
    AccessPatientHistory = 'ServicesAustralia_AccessPatientHistory',
    RegisterDevice = 'ServicesAustralia_RegisterDevice'
}
